import React from "react";
import ContentLoader from "react-content-loader";

const AboutPlaceholder = () => {
  return (
    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 opacity-100 m-auto">
        <ContentLoader viewBox="0 0 500 20" className="mb-1 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="70" />
        </ContentLoader>
      </div>
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-auto mt-3 opacity-100">
        <ContentLoader viewBox="0 0 500 120" className="mb-3 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="120" />
        </ContentLoader>
      </div>
    </div>
  );
};

export default AboutPlaceholder;
